import { Typography } from '@la/ds-ui-components';
import { getSiteId, useAppSelector } from '@la/services';
import { Activity, Program } from '@la/types';
import { useGetProgramSubProgramsQuery } from 'redux/services/programApi';

type SingleActivityViewHeaderProps = {
  activity?: Activity;
  program?: Program;
};
export default function SingleActivityViewHeader({
  activity,
  program,
}: SingleActivityViewHeaderProps) {
  const siteId = useAppSelector(getSiteId);

  const { data: subPrograms } = useGetProgramSubProgramsQuery(
    {
      siteId,
      programId: program?.id,
    },
    { skip: !program || !program?.master }
  );

  const subProgramName = subPrograms?.find(
    ({ id }) => id === activity?.teams[0].programId
  )?.name;

  return (
    <>
      <Typography variant="headline" size="xl">
        {program?.name}
      </Typography>
      <Typography variant="ui" size="xl">
        {subProgramName}
      </Typography>
    </>
  );
}
